
import React from 'react'
import StatusContext from '../../../contexts/StatusContext';
import AITestContext from '../../../contexts/AITestContext';
import {Container, Card} from 'react-bootstrap';
import { Check } from "@mui/icons-material"
import "./aitest.css";
import IconButton from '@mui/material/IconButton';


export const BuyTestSuccess = () => {
 

const {
  changeLanguage, 
  setTestName,
  testname
} = React.useContext(StatusContext);

const {
  handleBuyTest_Test
} = React.useContext(AITestContext);


const handleBuyTest = () =>
  {
    console.log("handleBuyTestSuccess")
    let buytest = JSON.parse(sessionStorage.getItem('buyteststatus'))
    
    if (buytest !== null && buytest.status)
      {
        //save bought test
        setTestName(buytest.chat.chatname)
        
        sessionStorage.removeItem('buyteststatus')
        handleBuyTest_Test(buytest.chat)
      }
      else{
        console.log("Failed Saved bought test")
      }

  }
  
  
handleBuyTest()

console.log("BuySuccess page")

  return (
    <Container className= "homeContainer">
      <br></br>
     <div className="buytestsuccessContainer">
      <Card>
          <div className="buytestsuccessPlans">
           
          <IconButton>
            <Check className="buytestImage"/>
          </IconButton>
              <div className="buytestsuccessTitle">
                {changeLanguage('aitest', 'boughttest')}
              </div>
              <label className="buytestName">{testname}</label>

          </div>
          </Card>
     </div> 
     <br></br>

    </Container>
  );
};

export default BuyTestSuccess;
